import clsx from "clsx";
import { format } from "date-fns";
import { createPortal } from "react-dom";
import { colors } from "../../../ui/colors";
import { PlusIcon } from "../../../ui/icons/plus";
import { EventDTO } from "../dto";
import { DetailedListEvent } from "../events/detailedListEvent";

type Props = {
    visible: boolean
    events: EventDTO[]
    setVisibile: (visible: boolean) => void
    cleanEvents: () => void
}
export function ModalDetailsList(props: Props) {
    const { visible, setVisibile, events, cleanEvents } = props

    return createPortal(
        <div
            onClick={() => {
                setVisibile(false)
                cleanEvents()
            }}
            className={clsx(
                "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
                {
                    block: visible,
                    hidden: !visible
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                className="transition-all relative flex flex-col opacity-100 rounded-xl bg-white shadow-sm w-[25%]"
            >
                <div
                    onClick={() => { setVisibile(false); cleanEvents() }}
                    className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                >
                    <PlusIcon color={colors.brandPrimary[600]} size={16} />
                </div>
                <div className="p-6 text-heading-xs font-semibold text-center text-neutral-800">
                    {visible && <>Eventi del {format(new Date(events[0].startDate), 'dd/MM/yyyy')}</>}
                </div>
                <div className="px-6 py-8 flex flex-col gap-4 max-h-[50vh] overflow-y-auto border-t-neutral-200 border-t">
                    {events.map(event => <DetailedListEvent event={event} />)}
                </div>
            </div>
        </div >
        , document.body)
}